<template>
  <button
    type="button"
    class="import-action"
    :disabled="!enabled || importing"
    :aria-busy="importing"
    data-test="import-action"
    @click="$emit('import')"
  >
    <span v-if="importing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span>{{ importing ? $t('import_files.importing') : label }}</span>
  </button>
</template>

<script setup lang="ts">
// The yellow action button: says exactly what will be created ("Import 10 recordings and 2
// waypoint groups", "Open in planner"), greyed out on "Nothing to import" and while reading.
defineProps<{ label: string; enabled: boolean; importing: boolean }>();
defineEmits<{ (e: 'import'): void }>();
</script>

<style scoped>
.import-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 10px 24px;
  border: 0;
  border-radius: 10px;
  background: var(--yellow);
  color: #000;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.import-action:disabled {
  background: #3a3c44;
  color: var(--text-muted);
  cursor: not-allowed;
}
.import-action[aria-busy='true'] {
  background: var(--yellow);
  color: #000;
  opacity: 0.6;
}
</style>
